import React from 'react';
import { useStore } from '../../../../stores/root';

// assets

// services
import UserService from '../../../../services/users/user';

// props
import { IUserResourceShortProps } from '../../../../props/users/user';

// components
import { DefaultButton, Panel, PanelType, PrimaryButton, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import Label from '../../../typography/label';
import Text from '../../../typography/text';
import Tag from '../../../uiframeworks/tag';

interface VerifyUserFormProps {
    user: IUserResourceShortProps;
    onDismissed(refresh?: boolean): void;
}

const VerifyUserForm: React.FC<VerifyUserFormProps> = (props: VerifyUserFormProps) => {
    const { banner } = useStore();
    const [submitting, setSubmitting] = React.useState<boolean>(false);

    const _onSubmit = async () => {
        try {
            setSubmitting(true);
            await UserService.setVerified(props.user.id);

            banner.add({
                key: 'verify_user_success',
                variant: 'success',
                icon: faCheck,
                text: `User "${props.user.name}" is now verified`
            });
            props.onDismissed(true);
        } catch (e) {
            setSubmitting(false);
        }
    }

    return <Panel headerText={"Verify User"}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed(false)}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                {
                    !submitting ? (
                        <>
                            <PrimaryButton text={"Verify"} onClick={_onSubmit} />
                            <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed(false) }} />
                        </>
                    ) : null
                }
                {submitting ? <Spinner size={SpinnerSize.medium} labelPosition={"right"} label={"Verifying user ..."} /> : null}
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 20 } }}>
            <Text>Are you sure this user is 100% verified?</Text>
            <Stack.Item>
                <Label>Email Address</Label>
                <Text>{props.user.email}</Text>
            </Stack.Item>
            <Stack.Item>
                <Label>Name</Label>
                <Text>{props.user.name}</Text>
            </Stack.Item>
            <Stack.Item>
                <Label>Address</Label>
                <Text>{props.user.address || "-"}</Text>
            </Stack.Item>
            <Stack.Item>
                <Label>Phone Number</Label>
                <Text>{props.user.phoneNumber || "-"}</Text>
            </Stack.Item>
            {props.user.roles && props.user.roles.length > 0 ? <Stack.Item>
                <Label>Roles</Label>
                <Stack horizontal tokens={{childrenGap: 10}} wrap>
                    {props.user.roles.map((role) => <Tag text={role.name} />)}
                </Stack>
            </Stack.Item> : null}
            {props.user.companies && props.user.companies.length > 0 ? <Stack.Item>
                <Label>Related Companies</Label>
                <Stack horizontal tokens={{childrenGap: 10}} wrap>
                    {props.user.companies.map((company) => <Tag text={company.name} />)}
                </Stack>
            </Stack.Item> : null}
        </Stack>
    </Panel>
};

export default VerifyUserForm;
